import React from 'react';
import { Modal, ConfigProvider, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAppData } from './context/DataContext';
import ShareButton from "./ShareButton";

function RegisterModal(props) {
    const { userInfo } = useAppData();
    const navigate = useNavigate();
    
    const ensureHttps = (url) => {
        if (!url.startsWith("https://")) {
            return "https://" + url;
        }
        return url;
    };

    const externalLink = ensureHttps(props.info.tickets_link);

    const shouldRender =
        props.info.tickets_link !== null &&
        props.info.tickets_link !== "N/A" &&
        props.info.tickets_link !== "";

    // Check user profile completion status conditions
    const hasQuizResponse = userInfo && userInfo._id && userInfo.quizResponse;
    const hasPhoneNumber = userInfo && userInfo._id && userInfo.phone;
    
    // Determine which prompt to show based on requirements:
    // 1. If user has both phone number AND quizResponse, no prompt should show
    // 2. If user has no quizResponse, prompt to take the quiz
    // 3. If user has quizResponse but no phone number, prompt to add phone
    const shouldShowQuizPrompt = userInfo && userInfo._id && !hasQuizResponse;
    const shouldShowPhonePrompt = userInfo && userInfo._id && hasQuizResponse && !hasPhoneNumber;

    const handleClose = async () => {
        await props.setTrigger(false);
        window.location.reload();
    };

    const handleTakeQuiz = () => {
        props.setTrigger(false);
        navigate('/quiz');
    };

    const handleAddPhone = () => {
        // Here we can either navigate to a dedicated page or
        // we'll let the central prompt system handle it upon next session
        props.setTrigger(false);
        
        // Reset the prompt session flag to allow showing phone prompt
        sessionStorage.removeItem('prompt_shown_this_session');
        
        // Redirect to profile page where they can add phone
        navigate('/profile/' + userInfo._id);
    };

    return (
        <ConfigProvider
        theme={{
            components: {
                Modal: {
                    titleFontSize: 24,

                },
            },
        }}
    >
        <Modal
            open={props.trigger}
            onCancel={handleClose}
            footer={null}
            width={400}
            centered
            title= "You're Going!"
            // {
            //     <div className="title-icon">
            //         <span className="rm-title">You're Going!</span>
            //         <SuccessIcon className="success-icon" />
            //     </div>
            // }
            className="registration-modal"
        >
            {shouldRender ? (
                <>
                    <p className="rm-button-label">
                        A confirmation email has been sent to you! This event requires further registration:
                    </p>
                    <div className="next-step-share">
                        <a 
                            href={externalLink} 
                            className="next-step-link" 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            <button className="next-step-registration">
                                Click Here to Continue
                            </button>
                        </a>
                        <ShareButton 
                            buttontext="" 
                            styling="ns-register-modal-share" 
                            iconstyling="ns-rm-share-button-icon" 
                        />
                    </div>
                </>
            ) : (
                <>
                    <p className="rm-subtext">
                    A confirmation email has been sent to you! This event has been saved to your registered events.
                    </p>
                </>
            )}
            
            {/* Show quiz prompt if user hasn't completed the quiz */}
            {shouldShowQuizPrompt && (
                <div style={{ 
                    marginTop: '20px', 
                    padding: '15px', 
                    backgroundColor: '#f5f5f5', 
                    borderRadius: '8px',
                    textAlign: 'center'
                }}>
                    <p style={{ 
                        fontSize: '14px', 
                        marginBottom: '10px'
                    }}>
                        Want more personalized event recommendations?
                    </p>
                    <Button 
                        type="primary" 
                        onClick={handleTakeQuiz}
                        style={{ marginBottom: '5px' }}
                    >
                        Take Our Quick Quiz
                    </Button>
                </div>
            )}
            
            {/* Show phone prompt only if quiz is completed but no phone number */}
            {shouldShowPhonePrompt && (
                <div style={{ 
                    marginTop: '20px', 
                    padding: '15px', 
                    backgroundColor: '#f5f5f5', 
                    borderRadius: '8px',
                    textAlign: 'center'
                }}>
                    <p style={{ 
                        fontSize: '14px', 
                        marginBottom: '10px'
                    }}>
                        Want to receive text reminders for this event?
                    </p>
                    <Button 
                        type="primary" 
                        onClick={handleAddPhone}
                        style={{ marginBottom: '5px' }}
                    >
                        Add Phone Number
                    </Button>
                </div>
            )}
        </Modal>
        </ConfigProvider>
    );
}

export default RegisterModal;